export const religiousAffiliationsConstant =[
  { label: 'African Methodist Episcopal', value: 'africanMethodistEpiscopal' },
  { label: 'African Methodist Episcopal Zion Church', value: 'africanMethodistEpiscopalZionChurch' },
  { label: 'American Baptist', value: 'americanBaptist' },
  { label: 'American Evangelical Lutheran Church', value: 'americanEvangelicalLutheranChurch' },
  { label: 'Assemblies of God Church', value: 'assembliesOfGodChurch' },
  { label: 'Baptist', value: 'baptist' },
  // { label: 'Brethren Church', value: 'brethrenChurch' },
  { label: 'Christ and Missionary Alliance Church', value: 'christAndMissionaryAllianceChurch' },
  { label: 'Christian Church (Disciples of Christ)', value: 'christianChurchDisciplesOfChrist' },
  { label: 'Christian Churches and Churches of Christ', value: 'christianChurchesAndChurchesOfChrist' },
  { label: 'Christian Methodist Episcopal', value: 'christianMethodistEpiscopal' },
  { label: 'Christian Reformed Church', value: 'christianReformedChurch' },
  { label: 'Church of Brethren', value: 'churchOfBrethren' },
  { label: 'Church of God', value: 'churchOfGod' },
  { label: 'Church of the Nazarene', value: 'churchOfTheNazarene' },
  { label: 'Churches of Christ', value: 'churchesOfChrist' },
  // { label: 'Cumberland Presbyterian', value: 'cumberlandPresbyterian' },
  { label: 'Episcopal Church, Reformed', value: 'episcopalChurchReformed' },
  { label: 'Evangelical Christian', value: 'evangelicalChristian' },
  // { label: 'Evangelical Congregational Church', value: 'evangelicalCongregationalChurch' },
  { label: 'Evangelical Covenant Church of America', value: 'evangelicalCovenantChurchOfAmerica' },
  { label: 'Evangelical Free Church of America', value: 'evangelicalFreeChurchOfAmerica' },
  { label: 'Evangelical Lutheran Church', value: 'evangelicalLutheranChurch' },
  // { label: 'Franciscan Catholic', value: 'franciscanCatholic' },
  { label: 'Free Methodist', value: 'freeMethodist' },
  { label: 'Free Will Baptist Church', value: 'freeWillBaptistChurch' },
  { label: 'Friends', value: 'friends' },
  { label: 'General Baptist', value: 'generalBaptist' },
  { label: 'Greek Orthodox', value: 'greekOrthodox' },
  { label: 'Interdenominational', value: 'interdenominational' },
  { label: 'Jewish', value: 'jewish' },
  { label: 'Latter Day Saints (Mormon Church)', value: 'latterDaySaintsMormonChurch' },
  { label: 'Lutheran Church, Missouri Synod', value: 'lutheranChurchMissouriSynod' },
  { label: 'Lutheran Church in America', value: 'lutheranChurchInAmerica' },
  // { label: 'Mennonite Brethren Church', value: 'mennoniteBrethrenChurch' },
  { label: 'Mennonite Church', value: 'mennoniteChurch' },
  { label: 'Missionary Church Inc', value: 'missionaryChurchInc' },
  { label: 'Moravian Church', value: 'moravianChurch' },
  // { label: 'Multiple Protestant Denomination', value: 'multipleProtestantDenomination' },
  { label: 'Nondenominational Christianity', value: 'nondenominationalChristianity' },
  { label: 'Nonsectarian Catholic', value: 'nonsectarianCatholic' },
  // { label: 'North American Baptist', value: 'northAmericanBaptist' },
  { label: 'Original Free Will Baptist', value: 'originalFreeWillBaptist' },
  { label: 'Other Protestant', value: 'otherProtestant' },
  { label: 'Pentecostal Holiness Church', value: 'pentecostalHolinessChurch' },
  { label: 'Presbyterian', value: 'presbyterian' },
  { label: 'Presbyterian Church (USA)', value: 'presbyterianChurchUsa' },
  { label: 'Protestant Episcopal', value: 'protestantEpiscopal' },
  // { label: 'Protestant, Not Specified', value: 'protestantNotSpecified' },
  { label: 'Reformed Church in America', value: 'reformedChurchInAmerica' },
  { label: 'Reformed Presbyterian Church', value: 'reformedPresbyterianChurch' },
  { label: 'Roman Catholic', value: 'romanCatholic' },
  // { label: 'Russian Orthodox', value: 'russianOrthodox' },
  { label: 'Seventh Day Adventists', value: 'seventhDayAdventists' },
  { label: 'Southern Baptist', value: 'southernBaptist' },
  { label: 'The Presbyterian Church in America', value: 'thePresbyterianChurchInAmerica' },
  // { label: 'Undenominational', value: 'undenominational' },
  // { label: 'Unitarian Universalist', value: 'unitarianUniversalist' },
  { label: 'United Brethren Church', value: 'unitedBrethrenChurch' },
  { label: 'United Church of Christ', value: 'unitedChurchOfChrist' },
  { label: 'United Methodist', value: 'unitedMethodist' },
  { label: 'Wesleyan', value: 'wesleyan' },
  // { label: 'Wisconsin Evangelical Lutheran Synod', value: 'wisconsinEvangelicalLutheranSynod' },
  { label: 'No Religious Affiliation', value: 'noReligiousAffiliation' },
]


export const ethnicityConstant = [
  { label: 'No ethnic affiliation', value: 'noEthnicAffiliation' },
  { label: 'Tribal Colleges', value: 'tribalColleges' },
  { label: 'Historically/Predominantly Black Colleges (HBCU)', value: 'historicallyPredominantlyBlackCollegesHbcu' },
  { label: 'Hispanic Serving Institution (HSI)', value: 'hispanicServingInstitutionHsi' },
]


// export const genderConstant = [
//     {'name':'Coed School', 'value':'Coed School'},
//     {'name':'All Female','value': 'All Female'},
//     {'name':'All Male','value':'All Male'}
// ]

export const genderConstant = [
  { label: 'Coed School', value: 'coedSchool' },
  { label: 'All Female', value: 'allFemale' },
  { label: 'All Male', value: 'allMale' },
]


export const durationConstant = [
  { label: '2 Year', value: '2year' },
  { label: '4 Year', value: '4year' },
  { label: 'Other', value: 'OTHER' },
]


export const calanderConstant = [
  { label: 'Semesters', value: "SEMESTERS" },
  { label: 'Quarters', value: "QUARTERS" },
  { label: 'Nontraditional', value: "NONTRADITIONAL" }
]

export const settingConstant = [
  { label: 'Urban', value: 'urban' },
  { label: 'Suburb', value: 'suburb' },
  { label: 'Town', value: 'town' },
  { label: 'Rural', value: 'rural' },
  { label: 'Online', value: 'online' },
]


export const accreditationConstant = [
  { label: 'Regional', value: 'REGIONAL' },
  { label: 'National', value: 'NATIONAL' },
  { label: 'Hybrid', value: 'HYBRID' },
  { label: 'Other', value: 'OTHER' }
]

export const collegeTypeConstatnt = [
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' },
]
